import React from "react";
import Table from "../../core/common/dataTable/index";
import { callsData } from "../../core/data/json/calls";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import { TableData } from "../../core/data/interface";
import CollapseHeader from "../../core/common/collapse-header";
import { useState } from "react";
import Slider from "rc-slider";
const route = all_routes;

const VoiceTemplate = () => {
  const dataSource = callsData;
  const [speed, setSpeed] = useState(50); // Initial value for Speed
  const [pitch, setPitch] = useState(50); // Initial value for Pitch

  const handleSpeedChange = (value: number | number[]) => {
    setSpeed(Array.isArray(value) ? value[0] : value);
  };

  const handlePitchChange = (value: number | number[]) => {
    setPitch(Array.isArray(value) ? value[0] : value);
  };
  const columns = [
    {
      title: " Template Name",
      dataIndex: "name",
      sorter: (a: TableData, b: TableData) => a.title.length - b.title.length,
      key: "title",
      width: "172px",
    },
    {
      title: "Message",
      dataIndex: "message",
      sorter: (a: TableData, b: TableData) => a.title.length - b.title.length,
      key: "title",
      width: "472px",
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (a: TableData, b: TableData) => a.status.length - b.status.length,
      key: "status",
      width: "90px",
      render: (status: any) => (
        <span
          className={`${
            status == "Active"
              ? "badge badge-pill badge-status bg-success"
              : status == "Inactive"
              ? "badge badge-pill badge-status bg-danger"
              : ""
          }`}
        >
          {status}
        </span>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      width: "90px",
      render: () => (
        <div className="dropdown table-action">
          <Link
            to="#"
            className="action-icon"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa fa-ellipsis-v" />
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            <Link
              className="dropdown-item"
              to="#"
              data-bs-target="#offcanvas_edit"
              data-bs-toggle="offcanvas"
            >
              <i className="ti ti-edit text-blue" /> Edit
            </Link>
            <Link
              className="dropdown-item"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#delete_calls"
            >
              <i className="ti ti-trash text-danger" /> Delete
            </Link>
          </div>
        </div>
      ),
    },
  ];

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-sm-8">
                    <h4 className="page-title">
                      Voice Template List
                      <span className="count-title">123</span>
                    </h4>
                  </div>
                  <div className="col-sm-4 text-sm-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="card">
                <div className="card-header">
                  {/* Search */}
                  <div className="row align-items-center">
                    <div className="col-sm-4">
                      <div className="icon-form mb-3 mb-sm-0">
                        <span className="form-icon">
                          <i className="ti ti-search" />
                        </span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search "
                        />
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="text-sm-end">
                        <Link
                          to="#"
                          className="btn btn-primary"
                          // data-bs-toggle="modal"
                          // data-bs-target="#add_calls"
                          data-bs-target="#offcanvas_add"
                          data-bs-toggle="offcanvas"
                        >
                          <i className="ti ti-square-rounded-plus me-2" />
                          Add Voice Template
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* /Search */}
                </div>
                <div className="card-body">
                  {/* Calls List */}
                  <div className="table-responsive custom-table">
                    <Table columns={columns} dataSource={dataSource} />
                  </div>
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <div className="datatable-length" />
                    </div>
                    <div className="col-md-6">
                      <div className="datatable-paginate" />
                    </div>
                  </div>
                  {/* /Calls List */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      {/* Add New Calls */}
      <div className="modal fade" id="add_calls" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Add New Call Reason</h5>
              <button
                className="btn-close custom-btn-close border p-1 me-0 text-dark"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form>
              <div className="modal-body">
                <div className="mb-3">
                  <label className="col-form-label">
                    Reason <span className="text-danger">*</span>
                  </label>
                  <input type="text" className="form-control" />
                </div>
                <div className="mb-0">
                  <label className="col-form-label">Status</label>
                  <div className="d-flex align-items-center">
                    <div className="me-2">
                      <input
                        type="radio"
                        className="status-radio"
                        id="add-active"
                        name="status"
                        defaultChecked
                      />
                      <label htmlFor="add-active">Active</label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        className="status-radio"
                        id="add-inactive"
                        name="status"
                      />
                      <label htmlFor="add-inactive">Inactive</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <div className="d-flex align-items-center justify-content-end m-0">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <button type="button" className="btn btn-primary">
                    Create
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Add New Calls */}
      {/* add voice template */}
      <div
        className="offcanvas  "
        style={{ width: "1250px", right: "0", top: "0" }}
        tabIndex={-1}
        id="offcanvas_add"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Add Voice Template</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div className="row  mb-3">
              <div className="col-md-6">
                <div className="form-group">
                  <label className="form-label">Language</label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti-user"></i>
                    </span>
                    <select
                      id="language_ddl"
                      name="language"
                      className="form-select"
                    >
                      <option value="QWZyaWthYW5zIChTb3V0aCBBZnJpY2Ep">
                        Afrikaans (South Africa)
                      </option>
                      <option value="QXJhYmlj">Arabic</option>
                      <option value="QmVuZ2FsaSAoSW5kaWEp">
                        Bengali (India)
                      </option>
                      <option value="QnVsZ2FyaWFuIChCdWxnYXJpYSk=">
                        Bulgarian (Bulgaria)
                      </option>
                      <option value="Q2F0YWxhbiAoU3BhaW4p">
                        Catalan (Spain)
                      </option>
                      <option value="Q2hpbmVzZSAoSG9uZyBLb25nKQ==">
                        Chinese (Hong Kong)
                      </option>
                      <option value="Q3plY2ggKEN6ZWNoIFJlcHVibGljKQ==">
                        Czech (Czech Republic)
                      </option>
                      <option value="RGFuaXNoIChEZW5tYXJrKQ==">
                        Danish (Denmark)
                      </option>
                      <option value="RHV0Y2ggKE5ldGhlcmxhbmRzKQ==">
                        Dutch (Netherlands)
                      </option>
                      <option value="RW5nbGlzaCAoQXVzdHJhbGlhKQ==">
                        English (Australia)
                      </option>
                      <option value="RW5nbGlzaCAoSW5kaWEp">
                        English (India)
                      </option>
                      <option value="RW5nbGlzaCAoVUsp">English (UK)</option>
                      <option value="RW5nbGlzaCAoVVMp">English (US)</option>
                      <option value="RmlsaXBpbm8gKFBoaWxpcHBpbmVzKQ==">
                        Filipino (Philippines)
                      </option>
                      <option value="RmlubmlzaCAoRmlubGFuZCk=">
                        Finnish (Finland)
                      </option>
                      <option value="RnJlbmNoIChDYW5hZGEp">
                        French (Canada)
                      </option>
                      <option value="RnJlbmNoIChGcmFuY2Up">
                        French (France)
                      </option>
                      <option value="R2VybWFuIChHZXJtYW55KQ==">
                        German (Germany)
                      </option>
                      <option value="R3JlZWsgKEdyZWVjZSk=">
                        Greek (Greece)
                      </option>
                      <option value="R3VqYXJhdGkgKEluZGlhKQ==">
                        Gujarati (India)
                      </option>
                      <option value="SGluZGkgKEluZGlhKQ==">
                        Hindi (India)
                      </option>
                      <option value="SHVuZ2FyaWFuIChIdW5nYXJ5KQ==">
                        Hungarian (Hungary)
                      </option>
                      <option value="SWNlbGFuZGljIChJY2VsYW5kKQ==">
                        Icelandic (Iceland)
                      </option>
                      <option value="SW5kb25lc2lhbiAoSW5kb25lc2lhKQ==">
                        Indonesian (Indonesia)
                      </option>
                      <option value="SXRhbGlhbiAoSXRhbHkp">
                        Italian (Italy)
                      </option>
                      <option value="SmFwYW5lc2UgKEphcGFuKQ==">
                        Japanese (Japan)
                      </option>
                      <option value="S2FubmFkYSAoSW5kaWEp">
                        Kannada (India)
                      </option>
                      <option value="S29yZWFuIChTb3V0aCBLb3JlYSk=">
                        Korean (South Korea)
                      </option>
                      <option value="TGF0dmlhbiAoTGF0dmlhKQ==">
                        Latvian (Latvia)
                      </option>
                      <option value="TWFsYXlhbGFtIChJbmRpYSk=">
                        Malayalam (India)
                      </option>
                      <option value="TWFuZGFyaW4gQ2hpbmVzZQ==">
                        Mandarin Chinese
                      </option>
                      <option value="Tm9yd2VnaWFuIChOb3J3YXkp">
                        Norwegian (Norway)
                      </option>
                      <option value="UG9saXNoIChQb2xhbmQp">
                        Polish (Poland)
                      </option>
                      <option value="UG9ydHVndWVzZSAoQnJhemlsKQ==">
                        Portuguese (Brazil)
                      </option>
                      <option value="UG9ydHVndWVzZSAoUG9ydHVnYWwp">
                        Portuguese (Portugal)
                      </option>
                      <option value="Um9tYW5pYW4gKFJvbWFuaWEp">
                        Romanian (Romania)
                      </option>
                      <option value="UnVzc2lhbiAoUnVzc2lhKQ==">
                        Russian (Russia)
                      </option>
                      <option value="U2VyYmlhbiAoQ3lyaWxsaWMp">
                        Serbian (Cyrillic)
                      </option>
                      <option value="U2xvdmFrIChTbG92YWtpYSk=">
                        Slovak (Slovakia)
                      </option>
                      <option value="U3BhbmlzaCAoU3BhaW4p">
                        Spanish (Spain)
                      </option>
                      <option value="U3BhbmlzaCAoVVMp">Spanish (US)</option>
                      <option value="U3dlZGlzaCAoU3dlZGVuKQ==">
                        Swedish (Sweden)
                      </option>
                      <option value="VGFtaWwgKEluZGlhKQ==">
                        Tamil (India)
                      </option>
                      <option value="VGVsdWd1IChJbmRpYSk=">
                        Telugu (India)
                      </option>
                      <option value="VGhhaSAoVGhhaWxhbmQp">
                        Thai (Thailand)
                      </option>
                      <option value="VHVya2lzaCAoVHVya2V5KQ==">
                        Turkish (Turkey)
                      </option>
                      <option value="VWtyYWluaWFuIChVa3JhaW5lKQ==">
                        Ukrainian (Ukraine)
                      </option>
                      <option value="VmlldG5hbWVzZSAoVmlldG5hbSk=">
                        Vietnamese (Vietnam)
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label className="form-label">Voice Name</label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti-user"></i>
                    </span>
                    <select
                      id="voice_name_ddl"
                      name="voice_name"
                      className="form-select"
                    >
                      <option value="en-US ## en-US-Neural2-A ## MALE">
                        en-US-Neural2-A (MALE){" "}
                      </option>
                      <option value="en-US ## en-US-Neural2-C ## FEMALE">
                        en-US-Neural2-C (FEMALE){" "}
                      </option>
                      <option value="en-US ## en-US-Neural2-D ## MALE">
                        en-US-Neural2-D (MALE){" "}
                      </option>
                      <option value="en-US ## en-US-Neural2-E ## FEMALE">
                        en-US-Neural2-E (FEMALE){" "}
                      </option>
                      <option value="en-US ## en-US-Neural2-F ## FEMALE">
                        en-US-Neural2-F (FEMALE){" "}
                      </option>
                      <option value="en-US ## en-US-Neural2-G ## FEMALE">
                        en-US-Neural2-G (FEMALE){" "}
                      </option>
                      <option value="en-US ## en-US-Neural2-H ## FEMALE">
                        en-US-Neural2-H (FEMALE){" "}
                      </option>
                      <option value="en-US ## en-US-Neural2-I ## MALE">
                        en-US-Neural2-I (MALE){" "}
                      </option>
                      <option value="en-US ## en-US-Neural2-J ## MALE">
                        en-US-Neural2-J (MALE){" "}
                      </option>
                      <option value="en-US ## en-US-Wavenet-A ## MALE">
                        en-US-Wavenet-A (MALE){" "}
                      </option>
                      <option value="en-US ## en-US-Wavenet-B ## MALE">
                        en-US-Wavenet-B (MALE){" "}
                      </option>
                      <option value="en-US ## en-US-Wavenet-C ## FEMALE">
                        en-US-Wavenet-C (FEMALE){" "}
                      </option>
                      <option value="en-US ## en-US-Wavenet-D ## MALE">
                        en-US-Wavenet-D (MALE){" "}
                      </option>
                      <option value="en-US ## en-US-Wavenet-E ## FEMALE">
                        en-US-Wavenet-E (FEMALE){" "}
                      </option>
                      <option value="en-US ## en-US-Wavenet-F ## FEMALE">
                        en-US-Wavenet-F (FEMALE){" "}
                      </option>
                      <option value="en-US ## en-US-Wavenet-G ## FEMALE">
                        en-US-Wavenet-G (FEMALE){" "}
                      </option>
                      <option value="en-US ## en-US-Wavenet-H ## FEMALE">
                        en-US-Wavenet-H (FEMALE){" "}
                      </option>
                      <option value="en-US ## en-US-Wavenet-I ## MALE">
                        en-US-Wavenet-I (MALE){" "}
                      </option>
                      <option value="en-US ## en-US-Wavenet-J ## MALE">
                        en-US-Wavenet-J (MALE){" "}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <label className="col-form-label">Template Name</label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <i className="ti-user"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    name="templete_name"
                  />
                </div>
              </div>
              <div className="col-md-3">
                <label className="col-form-label">Labels</label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <i className="ti-user"></i>
                  </span>
                  <select id="multiple_names" className="form-select">
                    <option value="{Business Type}">Business Type</option>
                    <option value="{New Label}">New Label</option>
                    <option value="{Current Phone System}">
                      Current Phone System
                    </option>
                    <option value="{No of Open Loans}">No of Open Loans</option>
                    <option value="{Factor Rate}">Factor Rate</option>
                    <option value="{Annual Revenue}">Annual Revenue</option>
                    <option value="{Business Age}">Business Age</option>
                    <option value="{Credit Score}">Credit Score</option>
                    <option value="{Lead Source}">Lead Source</option>
                    <option value="{Monthly Revenue}">Monthly Revenue</option>
                    <option value="{First Name}">First Name</option>
                    <option value="{Email}">Email</option>
                    <option value="{Funding Amount}">Funding Amount</option>
                    <option value="{Zip}">Zip</option>
                    <option value="{State}">State</option>
                    <option value="{City}">City</option>
                    <option value="{Mobile}">Mobile</option>
                    <option value="{Work Phone}">Work Phone</option>
                    <option value="{Legal Company Name}">
                      Legal Company Name
                    </option>
                    <option value="{Last Name}">Last Name</option>;
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <label className="col-form-label">Sender Details</label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <i className="ti-user"></i>
                  </span>
                  <select id="multiple_names" className="form-select">
                    <option value="{first_name}">first_name</option>
                    <option value="{last_name}">last_name</option>
                    <option value="{email}">email</option>
                    <option value="{mobile}">mobile</option>
                    <option value="{company_name}">company_name</option>
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <label className="col-form-label">Label</label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <i className="ti-user"></i>
                  </span>
                  <select id="multiple_names" className="form-select">
                    <option value="{Business Type}">Facebook</option>
                    <option value="{New Label}">Affiliate Link</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div>
                  <label className="form-label">Speed</label>
                  <Slider value={speed} onChange={handleSpeedChange} />
                  {speed}
                </div>
              </div>

              <div className="col-md-6">
                <div>
                  <label className="form-label">Pitch</label>
                  <Slider value={pitch} onChange={handlePitchChange} />
                  {pitch}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-10" style={{ paddingTop: "10px" }}>
                <label className="form-label">Template Preview </label>
                <textarea
                  typeof="text"
                  className="form-control"
                  name="templete_desc"
                  value=""
                  id="speech_text"
                ></textarea>
                <audio
                  style={{ display: "none" }}
                  id="test_audio"
                  preload="none"
                >
                  <source src="" type="audio/mp3" />
                </audio>
              </div>
              <div
                className="col-sm-2"
                style={{ paddingTop: "10px", marginTop: "20px" }}
              >
                <a
                  className="btn btn-primary"
                  href="javascript:void(0);"
                  style={{ marginTop: "22px" }}
                >
                  Listen
                </a>
              </div>
            </div>
            <hr></hr>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-primary me-2"
              >
                Add
              </button>
              <Link
                to="#"
                className="btn btn-light me-2"
                data-bs-dismiss="offcanvas"
              >
                Cancel
              </Link>
            </div>
          </form>
        </div>
      </div>
      {/* /add voice template */}
      {/* Edit  voice template */}
      <div
        className="offcanvas "
        style={{ width: "1250px", right: "0", top: "0" }}
        tabIndex={-1}
        id="offcanvas_edit"
      >
        <div className="offcanvas-header border-bottom">
          <h5 className="fw-semibold">Edit Voice Template</h5>
          <button
            type="button"
            className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="offcanvas-body">
          <form>
            <div className="row  mb-3">
              <div className="col-md-6">
                <div className="form-group">
                  <label className="form-label">Language</label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti-user"></i>
                    </span>
                    <select
                      id="language_ddl"
                      name="language"
                      className="form-select"
                    >
                      <option value="QWZyaWthYW5zIChTb3V0aCBBZnJpY2Ep">
                        Afrikaans (South Africa)
                      </option>
                      <option value="QXJhYmlj">Arabic</option>
                      <option value="QmVuZ2FsaSAoSW5kaWEp">
                        Bengali (India)
                      </option>
                      <option value="QnVsZ2FyaWFuIChCdWxnYXJpYSk=">
                        Bulgarian (Bulgaria)
                      </option>
                      <option value="Q2F0YWxhbiAoU3BhaW4p">
                        Catalan (Spain)
                      </option>
                      <option value="Q2hpbmVzZSAoSG9uZyBLb25nKQ==">
                        Chinese (Hong Kong)
                      </option>
                      <option value="Q3plY2ggKEN6ZWNoIFJlcHVibGljKQ==">
                        Czech (Czech Republic)
                      </option>
                      <option value="RGFuaXNoIChEZW5tYXJrKQ==">
                        Danish (Denmark)
                      </option>
                      <option value="RHV0Y2ggKE5ldGhlcmxhbmRzKQ==">
                        Dutch (Netherlands)
                      </option>
                      <option value="RW5nbGlzaCAoQXVzdHJhbGlhKQ==">
                        English (Australia)
                      </option>
                      <option value="RW5nbGlzaCAoSW5kaWEp">
                        English (India)
                      </option>
                      <option value="RW5nbGlzaCAoVUsp">English (UK)</option>
                      <option value="RW5nbGlzaCAoVVMp">English (US)</option>
                      <option value="RmlsaXBpbm8gKFBoaWxpcHBpbmVzKQ==">
                        Filipino (Philippines)
                      </option>
                      <option value="RmlubmlzaCAoRmlubGFuZCk=">
                        Finnish (Finland)
                      </option>
                      <option value="RnJlbmNoIChDYW5hZGEp">
                        French (Canada)
                      </option>
                      <option value="RnJlbmNoIChGcmFuY2Up">
                        French (France)
                      </option>
                      <option value="R2VybWFuIChHZXJtYW55KQ==">
                        German (Germany)
                      </option>
                      <option value="R3JlZWsgKEdyZWVjZSk=">
                        Greek (Greece)
                      </option>
                      <option value="R3VqYXJhdGkgKEluZGlhKQ==">
                        Gujarati (India)
                      </option>
                      <option value="SGluZGkgKEluZGlhKQ==">
                        Hindi (India)
                      </option>
                      <option value="SHVuZ2FyaWFuIChIdW5nYXJ5KQ==">
                        Hungarian (Hungary)
                      </option>
                      <option value="SWNlbGFuZGljIChJY2VsYW5kKQ==">
                        Icelandic (Iceland)
                      </option>
                      <option value="SW5kb25lc2lhbiAoSW5kb25lc2lhKQ==">
                        Indonesian (Indonesia)
                      </option>
                      <option value="SXRhbGlhbiAoSXRhbHkp">
                        Italian (Italy)
                      </option>
                      <option value="SmFwYW5lc2UgKEphcGFuKQ==">
                        Japanese (Japan)
                      </option>
                      <option value="S2FubmFkYSAoSW5kaWEp">
                        Kannada (India)
                      </option>
                      <option value="S29yZWFuIChTb3V0aCBLb3JlYSk=">
                        Korean (South Korea)
                      </option>
                      <option value="TGF0dmlhbiAoTGF0dmlhKQ==">
                        Latvian (Latvia)
                      </option>
                      <option value="TWFsYXlhbGFtIChJbmRpYSk=">
                        Malayalam (India)
                      </option>
                      <option value="TWFuZGFyaW4gQ2hpbmVzZQ==">
                        Mandarin Chinese
                      </option>
                      <option value="Tm9yd2VnaWFuIChOb3J3YXkp">
                        Norwegian (Norway)
                      </option>
                      <option value="UG9saXNoIChQb2xhbmQp">
                        Polish (Poland)
                      </option>
                      <option value="UG9ydHVndWVzZSAoQnJhemlsKQ==">
                        Portuguese (Brazil)
                      </option>
                      <option value="UG9ydHVndWVzZSAoUG9ydHVnYWwp">
                        Portuguese (Portugal)
                      </option>
                      <option value="Um9tYW5pYW4gKFJvbWFuaWEp">
                        Romanian (Romania)
                      </option>
                      <option value="UnVzc2lhbiAoUnVzc2lhKQ==">
                        Russian (Russia)
                      </option>
                      <option value="U2VyYmlhbiAoQ3lyaWxsaWMp">
                        Serbian (Cyrillic)
                      </option>
                      <option value="U2xvdmFrIChTbG92YWtpYSk=">
                        Slovak (Slovakia)
                      </option>
                      <option value="U3BhbmlzaCAoU3BhaW4p">
                        Spanish (Spain)
                      </option>
                      <option value="U3BhbmlzaCAoVVMp">Spanish (US)</option>
                      <option value="U3dlZGlzaCAoU3dlZGVuKQ==">
                        Swedish (Sweden)
                      </option>
                      <option value="VGFtaWwgKEluZGlhKQ==">
                        Tamil (India)
                      </option>
                      <option value="VGVsdWd1IChJbmRpYSk=">
                        Telugu (India)
                      </option>
                      <option value="VGhhaSAoVGhhaWxhbmQp">
                        Thai (Thailand)
                      </option>
                      <option value="VHVya2lzaCAoVHVya2V5KQ==">
                        Turkish (Turkey)
                      </option>
                      <option value="VWtyYWluaWFuIChVa3JhaW5lKQ==">
                        Ukrainian (Ukraine)
                      </option>
                      <option value="VmlldG5hbWVzZSAoVmlldG5hbSk=">
                        Vietnamese (Vietnam)
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label className="form-label">Voice Name</label>
                  <div className="input-group">
                    <span className="input-group-text">
                      <i className="ti-user"></i>
                    </span>
                    <select
                      id="voice_name_ddl"
                      name="voice_name"
                      className="form-select"
                    >
                      <option value="en-US ## en-US-Neural2-A ## MALE">
                        en-US-Neural2-A (MALE){" "}
                      </option>
                      <option value="en-US ## en-US-Neural2-C ## FEMALE">
                        en-US-Neural2-C (FEMALE){" "}
                      </option>
                      <option value="en-US ## en-US-Neural2-D ## MALE">
                        en-US-Neural2-D (MALE){" "}
                      </option>
                      <option value="en-US ## en-US-Neural2-E ## FEMALE">
                        en-US-Neural2-E (FEMALE){" "}
                      </option>
                      <option value="en-US ## en-US-Neural2-F ## FEMALE">
                        en-US-Neural2-F (FEMALE){" "}
                      </option>
                      <option value="en-US ## en-US-Neural2-G ## FEMALE">
                        en-US-Neural2-G (FEMALE){" "}
                      </option>
                      <option value="en-US ## en-US-Neural2-H ## FEMALE">
                        en-US-Neural2-H (FEMALE){" "}
                      </option>
                      <option value="en-US ## en-US-Neural2-I ## MALE">
                        en-US-Neural2-I (MALE){" "}
                      </option>
                      <option value="en-US ## en-US-Neural2-J ## MALE">
                        en-US-Neural2-J (MALE){" "}
                      </option>
                      <option value="en-US ## en-US-Wavenet-A ## MALE">
                        en-US-Wavenet-A (MALE){" "}
                      </option>
                      <option value="en-US ## en-US-Wavenet-B ## MALE">
                        en-US-Wavenet-B (MALE){" "}
                      </option>
                      <option value="en-US ## en-US-Wavenet-C ## FEMALE">
                        en-US-Wavenet-C (FEMALE){" "}
                      </option>
                      <option value="en-US ## en-US-Wavenet-D ## MALE">
                        en-US-Wavenet-D (MALE){" "}
                      </option>
                      <option value="en-US ## en-US-Wavenet-E ## FEMALE">
                        en-US-Wavenet-E (FEMALE){" "}
                      </option>
                      <option value="en-US ## en-US-Wavenet-F ## FEMALE">
                        en-US-Wavenet-F (FEMALE){" "}
                      </option>
                      <option value="en-US ## en-US-Wavenet-G ## FEMALE">
                        en-US-Wavenet-G (FEMALE){" "}
                      </option>
                      <option value="en-US ## en-US-Wavenet-H ## FEMALE">
                        en-US-Wavenet-H (FEMALE){" "}
                      </option>
                      <option value="en-US ## en-US-Wavenet-I ## MALE">
                        en-US-Wavenet-I (MALE){" "}
                      </option>
                      <option value="en-US ## en-US-Wavenet-J ## MALE">
                        en-US-Wavenet-J (MALE){" "}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <label className="col-form-label">Template Name</label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <i className="ti-user"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    name="templete_name"
                  />
                </div>
              </div>
              <div className="col-md-3">
                <label className="col-form-label">Labels</label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <i className="ti-user"></i>
                  </span>
                  <select id="multiple_names" className="form-select">
                    <option value="{Business Type}">Business Type</option>
                    <option value="{New Label}">New Label</option>
                    <option value="{Current Phone System}">
                      Current Phone System
                    </option>
                    <option value="{No of Open Loans}">No of Open Loans</option>
                    <option value="{Factor Rate}">Factor Rate</option>
                    <option value="{Annual Revenue}">Annual Revenue</option>
                    <option value="{Business Age}">Business Age</option>
                    <option value="{Credit Score}">Credit Score</option>
                    <option value="{Lead Source}">Lead Source</option>
                    <option value="{Monthly Revenue}">Monthly Revenue</option>
                    <option value="{First Name}">First Name</option>
                    <option value="{Email}">Email</option>
                    <option value="{Funding Amount}">Funding Amount</option>
                    <option value="{Zip}">Zip</option>
                    <option value="{State}">State</option>
                    <option value="{City}">City</option>
                    <option value="{Mobile}">Mobile</option>
                    <option value="{Work Phone}">Work Phone</option>
                    <option value="{Legal Company Name}">
                      Legal Company Name
                    </option>
                    <option value="{Last Name}">Last Name</option>;
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <label className="col-form-label">Sender Details</label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <i className="ti-user"></i>
                  </span>
                  <select id="multiple_names" className="form-select">
                    <option value="{first_name}">first_name</option>
                    <option value="{last_name}">last_name</option>
                    <option value="{email}">email</option>
                    <option value="{mobile}">mobile</option>
                    <option value="{company_name}">company_name</option>
                  </select>
                </div>
              </div>
              <div className="col-md-3">
                <label className="col-form-label">Label</label>
                <div className="input-group mb-3">
                  <span className="input-group-text">
                    <i className="ti-user"></i>
                  </span>
                  <select id="multiple_names" className="form-select">
                    <option value="{Business Type}">Facebook</option>
                    <option value="{New Label}">Affiliate Link</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div>
                  <label className="form-label">Speed</label>
                  <Slider value={speed} onChange={handleSpeedChange} />
                  {speed}
                </div>
              </div>

              <div className="col-md-6">
                <div>
                  <label className="form-label">Pitch</label>
                  <Slider value={pitch} onChange={handlePitchChange} />
                  {pitch}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12" style={{ paddingTop: "10px" }}>
                <label className="form-label">Template Preview </label>
                <textarea
                  typeof="text"
                  className="form-control"
                  name="templete_desc"
                  value=""
                  id="speech_text"
                ></textarea>
                <audio
                  style={{ display: "none" }}
                  id="test_audio"
                  preload="none"
                >
                  <source src="" type="audio/mp3" />
                </audio>
              </div>
            </div>
            <hr></hr>
            <div className="d-flex align-items-center justify-content-end">
              <button
                type="button"
                data-bs-dismiss="offcanvas"
                className="btn btn-primary me-2"
              >
                Listen
              </button>
              <Link
                to="#"
                className="btn btn-light me-2"
                data-bs-dismiss="offcanvas"
              >
                Update
              </Link>
            </div>
          </form>
        </div>
      </div>
      {/* /Edit add voice template */}
      {/* Delete Calls */}
      <div className="modal fade" id="delete_calls" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="text-center">
                <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
                  <i className="ti ti-trash-x fs-36 text-danger" />
                </div>
                <h4 className="mb-2">Confirm Delete</h4>
                <p className="mb-0">You are about to delete Voice Template..</p>
                <p className="mb-0">Do you want to proceed?</p>
                <div className="d-flex align-items-center justify-content-center mt-4">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    data-bs-dismiss="modal"
                    className="btn btn-danger"
                  >
                    Yes, Delete it
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Delete Calls */}
    </>
  );
};

export default VoiceTemplate;
